(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/tipsen-nav.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/tipsen-nav.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem,
  ItemsMenuIcon = _svs$ui$ReactItemsMen.ItemsMenuIcon;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _svs$core$data = svs.core.data,
  baseUrl = _svs$core$data.baseUrl,
  routes = _svs$core$data.routes;
const _ref = svs.tipsen.data || {},
  menuItems = _ref.menuItems;
const useBranding = svs.components.tipsen.hooks.useBranding;
const _ReactRouterDOM2 = ReactRouterDOM,
  useLocation = _ReactRouterDOM2.useLocation,
  matchPath = _ReactRouterDOM2.matchPath;
const detect = svs.core.detect;
const selectDisplayName = svs.components.tipsen.engine.selectors.engineSelectors.selectDisplayName;
let navEl = document.querySelector('#tipsen-nav');
if (navEl === null) {
  navEl = document.createElement('div');
  document.body.appendChild(navEl);
}
let mainEl = document.querySelector('#tipsen');
if (mainEl === null) {
  mainEl = document.createElement('div');
  document.body.appendChild(mainEl);
}
const getNumber = str => parseInt(str, 10);
const getSelectedIndex = items => {
  const slicedItems = items.slice(0);
  slicedItems.sort((a, b) => b.url.length - a.url.length);
  let selectedIndex = 0;
  for (let i = 0; i < slicedItems.length; ++i) {
    if (slicedItems[i].url.length > location.pathname.length) {
      continue;
    }
    if (location.pathname.startsWith(slicedItems[i].url)) {
      selectedIndex = i;
      break;
    }
  }
  return items.indexOf(slicedItems[selectedIndex]);
};
const isClientRoute = url => {
  for (const modulePath of Object.keys(routes)) {
    const match = matchPath(url, {
      path: baseUrl + modulePath,
      exact: true,
      strict: false
    });
    if (match !== null) {
      return true;
    }
  }
  return false;
};
const flaggedMenuItems = (menuItems || []).map(menuItem => _objectSpread(_objectSpread({}, menuItem), {}, {
  isClientRoute: isClientRoute(menuItem.url)
})).filter(menuItem => {
  if (menuItem.ftName) {
    return detect.feature(menuItem.ftName);
  }
  return true;
});
const TipsenNav = () => {
  const isWideScreen = useMediaQuery(breakpoints.up(BREAKPOINT_SM));
  const brandingList = useBranding();
  const branding = brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const location = useLocation();
  const _useState = useState(() => getSelectedIndex(flaggedMenuItems)),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  const displayName = useSelector(state => selectDisplayName(state));
  useEffect(() => {
    const ownPadding = getNumber(getComputedStyle(mainEl).paddingBottom);
    const tabbedNavStyle = getComputedStyle(navEl);
    const shadowYOffset = getNumber(tabbedNavStyle.getPropertyValue('--box-shadow-y-offset'));
    const shadowBlur = getNumber(tabbedNavStyle.getPropertyValue('--box-shadow-blur-radius'));
    if (isWideScreen) {
      mainEl.style.paddingBottom = "".concat(Number(ownPadding), "px");
    } else {
      mainEl.style.paddingBottom = "".concat(Number(ownPadding) + shadowYOffset + shadowBlur + navEl.offsetHeight, "px");
    }
  }, [isWideScreen]);
  useEffect(() => {
    setSelectedIndex(getSelectedIndex(flaggedMenuItems));
  }, [location.pathname]);
  return ReactDOM.createPortal(React.createElement(ItemsMenu, {
    ariaLabel: "".concat(displayName, "s huvudmeny"),
    branding: "".concat(branding, "-main-nav"),
    centered: true,
    className: "tipsen-items-menu",
    compact: !isWideScreen
  }, flaggedMenuItems.map((menuItem, index) => {
    const linkItemProps = {};
    if (menuItem.isClientRoute) {
      linkItemProps.Component = Link;
      const url = menuItem.url.slice(baseUrl.length);
      linkItemProps.to = {
        pathname: url.length === 0 ? '/' : url
      };
    } else {
      linkItemProps.Component = 'a';
      linkItemProps.href = menuItem.url;
    }
    return React.createElement(LinkItem, _extends({
      badge: menuItem.extraConfig.isBadge,
      badgeNr: menuItem.extraConfig.badgeNr,
      key: "".concat(menuItem.label, ";").concat(menuItem.url),
      label: menuItem.label,
      onClick: () => setSelectedIndex(index),
      selected: selectedIndex === index
    }, linkItemProps), Boolean(menuItem.extraConfig.icon) && React.createElement(ItemsMenuIcon, {
      icon: menuItem.extraConfig.icon,
      position: isWideScreen ? 'left' : 'top',
      size: "200"
    }));
  })), navEl);
};
setGlobal('svs.components.tipsen.modularBase.TipsenNav', TipsenNav);

 })(window);